import { createI18n } from 'vue-i18n';
import es from './es';

export default createI18n({
  locale: 'es',
  messages: {
    es,
  },
});
